import React from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import Layout from '~/components/Layout'
import { ManagerQuery } from '~/QueryHooks/ManagerQuery'
import { Menu } from 'semantic-ui-react'
import Show from './Show'
import { RouteTypes } from '~/routes/constants'

const ManagerProfile: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()

  const {
    data: profileData,
    isLoading
  } = ManagerQuery.getProfileData()

  const tabs = [
    { label: t('Farmers'), to: RouteTypes.MANAGER_PROFILE_FARMERS },
    { label: t('Registration program'), to: RouteTypes.MANAGER_PROFILE_REGISTRATIONS }
  ]

  return (
    <Layout title={t('Manager Profile')} segmented isBusy={isLoading}>
      {profileData?.manager && <Show showData={profileData.manager} />}
      <Menu secondary pointing>
        {tabs.map(tab => (
          <Menu.Item
            key={tab.to}
            active={location.pathname === tab.to}
            onClick={() => navigate(tab.to)}
          >
            {tab.label}
          </Menu.Item>
        ))}
      </Menu>
      <Outlet />
    </Layout>
  )
}

export default ManagerProfile
